import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/talk/mutations'
import { path } from '@/store/talk/types'
import { mutation } from '@/utils/mutation'
import state, { ITalkState } from '@/store/talk/state'

export * from '@/store/talk/state'

export const store: Module<ITalkState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
